import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';

import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

import config from '../../config';
import styles from './Loader.css';

export default class Loader extends Component {
    componentDidMount() {
        NProgress.start();
    }

    componentWillUnmount() {
        NProgress.done();
    }

    render() {
        if(!this.props.hideContent) {
            return (
                <div className={`${styles.wrapper} loader-wrapper`} style={{ minHeight: '300px', textAlign: 'center', padding: '50px' }}>
                    <img src={`${config.url}assets/images/logo.png`} alt={config.application.name} style={{ maxWidth: '100px' }} /><br /><br />
                    <FontAwesome name="spinner" spin size="lg" className="text-primary" />
                </div>
            );
        }
        return null;
    }
}

Loader.defaultProps = {
    hideContent: false,
};

Loader.propTypes = {
    hideContent: PropTypes.bool,
};
